// Church Center
import AttendeeSelectionContainer from "components/church_center/attendee_selection_container"
import GuestLoginForm from "components/church_center/guest_login_form"
import PaymentForm from "components/church_center/payment_form"
import EmergencyContact from "components/church_center/EmergencyContact"

// Admin
import AdminPaymentsContainer from "components/admin/admin_payments_container"
import AdminPaymentShow from "components/admin/admin_payment_show"
import AssignmentType from "components/admin/AssignmentType"
import AssignmentTypes from "components/admin/AssignmentTypes"
import AssignmentAreaRestrictionSelection from "components/admin/assignment_area_restriction_selection"
import AttendanceDropdown from "components/admin/AttendanceDropdown"
import AttendanceReports from "components/admin/AttendanceReports"
import { CampusCategoryPane } from "components/admin/legacySettingPanes"
import CheckInsStations from "components/admin/CheckInsStations"
import { ConnectedEventsDropdown } from "@planningcenter/connected-events"
import DatePicker from "components/ui/DatePicker"
import Event from "components/admin/Event"
import EventActions from "components/admin/events/event_actions"
import EventLogo from "components/admin/events/event_logo"
import EventLocation from "components/admin/events/event_location"
import EventVisibility from "components/admin/events/EventVisibility"
import EventsIndex from "components/admin/events/Events"
import EventsNew from "components/admin/events/new"
import EventTimeContainer from "components/admin/Event/SignUpDatesAndTimes"
import NotificationListSettings from "components/admin/settingPanes/NotificationListSettings"
import PaymentSettings from "components/admin/settingPanes/PaymentSettings"
import FormEdit from "components/admin/forms/form_edit"
import FormsIndex from "components/admin/forms/forms_index"
import ManageCategories from "components/admin/manage_categories"
import Managers from "components/admin/managers"
import Transactions from "components/admin/payments_sort/Transactions"
import PeopleIndex from "components/admin/people/index"
import ProfileDropdown from "components/admin/profile_dropdown"
import Questions from "components/admin/Questions/Questions"
import RegistrationContact from "components/admin/registration_contact"
import RegistrationsNew from "components/admin/RegistrationsNew"
import RegistrationShow from "components/admin/LegacyRegistration/Show"
import RegistrationStatus from "components/admin/events/RegistrationStatus"
import RegistrationsToolbar from "components/admin/RegistrationsToolbar"
import Reservation from "components/admin/Reservation"
import Registration from "components/admin/Registration"
import StaffActionsDropdown from "components/admin/staff_actions_dropdown"
import StaffActionsEventDropdown from "components/admin/staff_actions_event_dropdown"
import ScholarshipsIndex from "components/admin/scholarships"
import SideNav from "components/ui/SideNav"
import CheckInsDropdown from "components/admin/check_ins_dropdown"
import EventConfirmationEmail from "components/admin/Event/EventConfirmationEmail"
import SchedulableEmails from "components/admin/SchedulableEmails/SchedulableEmails"
import SelectionTypes from "components/admin/SelectionTypes"
import SignupDuplicationForm from "components/admin/Signup/DuplicationForm"
import SignupRegistrationSettings from "components/admin/Signup/RegistrationSettings"
import SignupAttendeeSettings from "components/admin/Signup/AttendeeSettings"
import SignupRegistrationSettingsForm from "components/admin/Signup/RegistrationSettingsForm"
import SignUpName from "components/admin/Event/SignUpName"
import SignUpDatesAndTimes from "components/admin/Event/SignUpDatesAndTimes"
import SignUpDescription from "components/admin/Event/SignUpDescription"
import SignupSubscribers from "components/admin/settingPanes/SignupSubscribers"
import TextEditor from "components/admin/TextEditor"
import SignupAutomations from "./components/admin/Automations/SignupAutomations"
import StaffOverageDetail from "components/admin/StaffOverageDetail/StaffOverageDetail"

// Shared
import AutosaveForm from "components/shared/autosave_form"
import Link from "components/shared/link"
import LocationMap from "components/shared/location_map"
import AppProvider from "components/shared/AppProvider"

const Components = {
  Admin: {
    AdminPaymentsContainer,
    AdminPaymentShow,
    AssignmentType,
    AssignmentTypes,
    AssignmentAreaRestrictionSelection,
    AttendanceDropdown,
    AttendanceReports,
    CampusCategoryPane,
    CheckInsDropdown,
    CheckInsStations,
    ConnectedEventsDropdown,
    EventActions,
    EventConfirmationEmail,
    DatePicker,
    EventsIndex,
    EventsNew,
    Event,
    EventLocation,
    EventLogo,
    EventTime: EventTimeContainer,
    EventVisibility,
    FormEdit,
    FormsIndex,
    ManageCategories,
    Managers,
    Transactions,
    PeopleIndex,
    ProfileDropdown,
    Questions,
    RegistrationContact,
    RegistrationsNew,
    PaymentSettings,
    RegistrationShow,
    RegistrationStatus,
    Reservation,
    Registration,
    RegistrationsToolbar,
    SchedulableEmails,
    ScholarshipsIndex,
    SelectionTypes,
    SideNav,
    SignupDuplicationForm,
    SignupRegistrationSettings,
    SignupAttendeeSettings,
    SignupRegistrationSettingsForm,
    SignupSubscribers,
    SignUpName,
    StaffActionsDropdown,
    StaffActionsEventDropdown,
    NotificationListSettings,
    SignUpDatesAndTimes,
    SignUpDescription,
    TextEditor,
    SignupAutomations,
    StaffOverageDetail
  },
  ChurchCenter: {
    AttendeeSelectionContainer,
    DatePicker,
    EmergencyContact,
    GuestLoginForm,
    PaymentForm
  },
  Shared: {
    AppProvider,
    AutosaveForm,
    Link,
    LocationMap
  }
}

export default Components
